// import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const CrystalClearImagingContent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "32px",
            textAlign: "left",
          }}
        >
          <img
            src="/Doctorprofile.png"
            alt="Crystal Clear Imaging Radiologist"
            style={{
              width: "220px",
              height: "220px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #ddd",
              flexShrink: 0,
            }}
          />

          <div
            className="vertical-divider"
            style={{
              width: "2px",
              backgroundColor: "#ccc",
              height: "100%",
              minHeight: "160px",
              display: "none",
            }}
          ></div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              flex: 1,
              minWidth: "260px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
              className="content-container"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
                className="inner-content"
              >
                <div style={{ flex: 1 }}>
                  <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Crystal Clear Imaging (IIMS Hospital)
                  </h2>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Specialization:</strong> Radiologist & Your Window to the Womb
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Experience:</strong> 18 Years, specializing in obstetric ultrasonography
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Degrees:</strong> MBBS, MD (Radiodiagnosis), Fellowship in Foetal Medicine from Premier Medical Institute
                  </p>
                </div>

                <div
                  className="vertical-divider"
                  style={{
                    width: "2px",
                    backgroundColor: "#ccc",
                    height: "100%",
                    minHeight: "160px",
                    display: "none",
                  }}
                ></div>

                <div style={{ flex: 1 }}>
                  <p
                    style={{
                      fontStyle: "italic",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      color: "#444",
                      marginTop: "4px",
                    }}
                  >
                    "An ultrasound is more than a medical image; it's the first hello. Our passion is to
                    use technology to tell a story of health, providing you with clarity and profound
                    peace of mind."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
          {`
            @media (min-width: 768px) {
              .vertical-divider {
                display: block !important;
              }
        
              .inner-content {
                flex-direction: row !important;
              }
            }
        
            @media (max-width: 767px) {
              .doctor-intro-container {
                flex-direction: column;
                align-items: center !important;
                text-align: center !important;
              }
        
              .inner-content {
                flex-direction: column !important;
                align-items: center !important;
                text-align: center !important;
              }
        
              .content-container {
                align-items: center !important;
                text-align: center !important;
              }
            }
          `}
        </style>


      <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
        <h3>My Philosophy on Sonography:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          We see myself as a medical storyteller. Every scan is a crucial chapter in your pregnancy story, and We have the privilege of interpreting it for you. Our focus is on precision, detail, and, most importantly, communication. We take the time to explain what we are seeing, transforming a technical procedure into a moment of connection and reassurance. Our commitment is to ensure that you leave not just with a report, but with a clear understanding and a happy heart.
        </p>

        <h3 style={{ marginTop: "32px" }}>Why I Chose Myprega:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          Myprega’s integrated system allows us to be a true partner in the care team. Our findings are instantly shared and discussed with your gynaecologist and other experts, creating a seamless flow of information. This collaborative approach ensures that every detail is considered, providing a level of safety and thoroughness that is simply not possible in a fragmented system.
        </p>

        <h3 style={{ marginTop: "32px" }}>Beyond the Clinic:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          I am a classical music enthusiast and a trained violinist. The discipline and focus required for music are the same skills I bring to my medical practice. I also have a passion for astrophotography, finding beauty and order in the patterns of the universe, much like I do in my daily work.
        </p>
      </div>

      <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "24px",
            paddingTop: "32px",
          }}
        >
          {/* Favourite Book */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🎼 Favourite Instrument
            </p>
            <p style={{ color: "#333" }}>Violin – both my hobby and my teacher</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Hobby */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🌌 Favourite Hobby
            </p>
            <p style={{ color: "#333" }}>
              Astrophotography – capturing the universe one frame at a time
            </p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Quote */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              💬 Imaging Philosophy
            </p>
            <p style={{ color: "#333" }}>
              “Every scan is a story — we help you read it with clarity and compassion.”
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CrystalClearImagingContent;
